import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // デフォルト30秒（短時間の再訪問でキャッシュ活用）
      gcTime: 1000 * 60 * 30, // 30分間キャッシュを保持
      retry: 1, // リトライ1回
      refetchOnWindowFocus: false, // ウィンドウフォーカス時の再取得を無効化
      throwOnError: false, // エラーは error state で処理
    },
    mutations: {
      retry: 0,
    },
  },
})
